import React from 'react';
import { DateField } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import { updatePayoffSchema } from '../../../validation/vendorDashboard/cancelOrderSchema';

export interface IPayoffFormProps {
  eta?: string;
  onSubmit: (eta?: string | null) => void;
  readOnly: boolean;
}

export const ETAForm: React.FC<IPayoffFormProps> = ({ eta, onSubmit, readOnly }) => {
  return (
    <Formik
      initialValues={{
        eta: eta,
      }}
      enableReinitialize={true}
      validationSchema={updatePayoffSchema}
      onSubmit={({ eta }) => onSubmit(eta)}
    >
      {({ handleSubmit }) => (
        <Form>
          <DateField
            name={'eta'}
            label={'Estimated Due Date'}
            readOnly={readOnly}
            zIndex={201}
            onChange={() => handleSubmit()}
          />
        </Form>
      )}
    </Formik>
  );
};
